export default __webpack_public_path__ + "static/media/devices_default_icon.eda5cd18.svg";